<template>
  <div class="footer">© 2024 AUGam</div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  display: flex;
  width: 100%;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: 50px;
  flex-direction: row;
  background-color: inherit;
  position: absolute;
  bottom: 0;
}
</style>
